(function () {
  const sec = document.querySelector('[id^="blog-filter-"]');
  if (!sec) return;
  
  const blogHandle = sec.dataset.blog;
  const tagsWrap = sec.querySelector('.bf-tags');
  
  if (!tagsWrap) return;

  // Get current active tag from URL
  const getCurrentTag = () => {
    const pathParts = location.pathname.split('/');
    const taggedIndex = pathParts.indexOf('tagged');
    
    if (taggedIndex !== -1 && pathParts[taggedIndex + 1]) {
      return decodeURIComponent(pathParts[taggedIndex + 1]);
    }
    return '';
  };

  // Build URL for tag filter
  const makeTaggedURL = (tag) => {
    if (!tag) return `/blogs/${blogHandle}`;
    return `/blogs/${blogHandle}/tagged/${encodeURIComponent(tag)}`;
  };

  // Update button active states
  const updateButtonStates = () => {
    const currentTag = getCurrentTag();
    
    tagsWrap.querySelectorAll('.bf-tag-btn').forEach(btn => {
      const btnTag = btn.dataset.tag;
      const isActive = (currentTag === btnTag);
      
      btn.dataset.active = isActive.toString();
    });
  };

  // Handle button clicks
  tagsWrap.addEventListener('click', (e) => {
    const btn = e.target.closest('.bf-tag-btn');
    if (!btn) return;
    
    e.preventDefault();
    
    const tag = btn.dataset.tag;
    const url = makeTaggedURL(tag);
    
    // Navigate to the filtered URL (this will reload the page with filtered results)
    window.location.href = url;
  });

  // Initialize button states on page load
  updateButtonStates();

  // Handle browser back/forward
  window.addEventListener('popstate', () => {
    updateButtonStates();
  });
})();